import React,{ Component } from "react";
import Button from "../elements/Buttons";

class Notification extends Component{
    constructor(props){
        super(props);
    }
    componentDidUpdate(newProps){
        if(this.props.logList!==newProps.logList){
            //console.log(this.props.logList.type);
        }
        if(this.props.logList.message!==newProps.logList.message){
            //console.log(this.props.logList.message);
        }
    }
    /* To set Alert 
        this.setState({logs:{type:'',message:'',refId:'',icon:'fe fe-rotate-cw fe-spin'}});

        **type ::  success / error / info-icon / success-icon
        **icon ::  fe fe-rotate-cw fe-spin / 
        **message  :: Error / Success message text
        **refId  :: Any dynamic id to show (like - project id)
    */
    render(){
        if(this.props.logList.type==='success'){
            return(
                <div id='notify' className={`notify ${this.props.logList.refId}`}>
                    <span className="message-content">{this.props.logList.message}</span>
                    <Button
                        id="notify_close"
                        type="button"
                        classes="notify_close"
                        title="Refresh"
                        action={this.props.action}
                        areaLabel="Refresh"
                        svg="true"
                    >
                        <img src="resources/images/icons/close.svg" alt="" title=""/>
                    </Button>
                </div>
            )
        } 
        else{
            return(null);
        }         
    }
}
Notification.propTypes = {
    logList: React.propTypes.node,
    action: React.propTypes.node,
}
export default Notification;